import * as React from "react";
import { createContext, useContext } from "react";
import useStreamMetrics from "hooks/useStreamMetrics";
import { singleton } from "logic/singleton";
const EMPTY_CONTEXT = {
  metricsByStreamId: {},
  isInitialLoading: false,
  isError: false
};
const StreamMetricsContext = singleton(
  "contexts.StreamMetricsContext",
  () => createContext(EMPTY_CONTEXT)
);
export const StreamMetricsProvider = ({ streamIds, fields, children = void 0 }) => {
  const { metricsByStreamId, isInitialLoading, isError } = useStreamMetrics(streamIds, fields);
  const value = {
    metricsByStreamId,
    isInitialLoading,
    isError
  };
  return /* @__PURE__ */ React.createElement(StreamMetricsContext.Provider, { value }, children);
};
export const useStreamMetricsContext = () => useContext(StreamMetricsContext);
export const useStreamMetricsFor = (streamId) => {
  const { metricsByStreamId, isInitialLoading, isError } = useContext(StreamMetricsContext);
  return {
    metrics: metricsByStreamId[streamId],
    isInitialLoading,
    isError
  };
};
export default StreamMetricsContext;
